import React, { useState, useEffect, useRef } from 'react'
import { Grid, Box, Button } from '@mui/material'
import { number, func, string, object } from 'prop-types'
import sistema from '../../../services/http/sistema'
import FormatosExemplares from '../../../services/http/obras/FormatosExemplares'
import StatusExemplares from '../../../services/http/obras/StatusExemplares'
import { Exemplares } from '../../../services/http'
import SmallTextField from '../../../components/textfield/SmallTextfield'
import BaseAutoComplete from '../../../components/shared/BaseAutoComplete'
import GenerateValidators from '../../../services/GenerateValidators'
import { ValidationError } from 'yup'
import exemplarSchema from '../validations'

const FormExemplar = ({
  idExemplar,
  idObra,
  onSubmit,
  submitMethod,
  dados = {}
}) => {
  const [formatosExemplares, setFormatosExemplares] = useState([])
  const [statusExemplar, setStatusExemplar] = useState([])
  const [bibliotecasList, setBibliotecasList] = useState([])
  const [quantidade, setQuantidade] = useState(1)
  const [helpers, setHelpers] = useState({})
  const [form, setForm] = useState({
    obra_id: idObra,
    observacao: '',
    biblioteca_id: '',
    formato_exemplar_id: '',
    status_exemplar_id: ''
  })

  useEffect(() => {
    setForm({ ...form, obra_id: idObra })
  }, [idObra])

  const putExemplar = async event => {
    event.preventDefault()
    await Exemplares(idExemplar).update(form, {
      notification: 'success',
      message: 'Sucesso ao editar exemplar!'
    })
    resetForm()
    onSubmit()
  }

  const resetFormato = useRef()
  const resetBiblioteca = useRef()
  const resetStatus = useRef()

  function resetForm() {
    resetFormato.current()
    resetBiblioteca.current()
    resetStatus.current()
    setForm({
      obra_id: idObra,
      observacao: '',
      biblioteca_id: '',
      formato_exemplar_id: '',
      status_exemplar_id: ''
    })
    setQuantidade(1)
  }

  async function postExemplar() {
    try {
      await exemplarSchema.validate(
        { ...form, quantidade },
        { abortEarly: false }
      )

      const exemplarRequests = Array.from({ length: quantidade }, () =>
        Exemplares().store(form, {
          notification: true,
          message: 'Sucesso ao cadastrar exemplar!'
        })
      )

      await Promise.all(exemplarRequests)

      resetForm()
      onSubmit()
    } catch (e) {
      if (e instanceof ValidationError) {
        const helperText = GenerateValidators(e)
        setTimeout(() => {
          setHelpers({})
        }, 2000)

        setHelpers(helperText)
      }
    }
  }
  const getFormatosExemplares = async () => {
    const { data } = await FormatosExemplares().show({ per_page: -1 })
    setFormatosExemplares(data.data)
    return data.data
  }

  const getStatusExemplares = async () => {
    const { data } = await StatusExemplares().show({ per_page: -1 })
    setStatusExemplar(data.data)
    return data.data
  }

  const getBibliotecas = async () => {
    const { data } = await sistema().bibliotecas().show({ per_page: -1 })
    setBibliotecasList(data.data)
    return data.data
  }

  const dadosToForm = dados => {
    setForm({
      obra_id: idObra,
      observacao: dados.observacao || '',
      biblioteca_id: dados.biblioteca_id,
      formato_exemplar_id: dados.formato_exemplar_id,
      status_exemplar_id: dados.status_exemplar_id
    })
  }

  const init = async () => {
    await getFormatosExemplares()
    await getStatusExemplares()
    await getBibliotecas()
    if (submitMethod === 'put') dadosToForm(dados)
  }

  useEffect(() => {
    init()
  }, [])

  const submitOptions = {
    post: postExemplar,
    put: putExemplar,
    '': () => {}
  }
  const title = {
    post: 'Cadastrar',
    put: 'Editar'
  }

  const procurarBiblioteca = () => {
    return bibliotecasList.find(element => element.id === dados.biblioteca_id)
  }

  const procurarExemplares = () => {
    return formatosExemplares.find(
      element => element.id === dados.formato_exemplar_id
    )
  }

  const procurarStatus = () => {
    return statusExemplar.find(
      element => element.id === dados.status_exemplar_id
    )
  }

  const bibliotecaDefaultValue =
    submitMethod === 'put' ? procurarBiblioteca() : undefined

  const formatoDefaultValue =
    submitMethod === 'put' ? procurarExemplares() : undefined

  const statusDefaultValue =
    submitMethod === 'put' ? procurarStatus() : undefined

  return (
    <div>
      <Grid container rowSpacing={1}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={3}>
            <Grid xs={12} sm={2} item>
              <BaseAutoComplete
                defaultValue={formatoDefaultValue}
                list={formatosExemplares}
                listLabel="descricao"
                inputProps={{
                  label: 'Formato',
                  color: 'default',
                  ...helpers.formato_exemplar_id
                }}
                onChange={({ id }) => {
                  setForm({ ...form, formato_exemplar_id: id })
                }}
                reset={event => (resetFormato.current = event)}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <BaseAutoComplete
                defaultValue={bibliotecaDefaultValue}
                list={bibliotecasList}
                listLabel="apelido"
                inputProps={{
                  label: 'Biblioteca',
                  color: 'default',
                  ...helpers.biblioteca_id
                }}
                onChange={({ id }) => {
                  setForm({ ...form, biblioteca_id: id })
                }}
                reset={event => (resetBiblioteca.current = event)}
              />
            </Grid>
            <Grid xs={12} sm={2} item>
              <BaseAutoComplete
                defaultValue={statusDefaultValue}
                list={statusExemplar}
                listLabel="descricao"
                inputProps={{
                  label: 'Status',
                  color: 'default',
                  ...helpers.status_exemplar_id
                }}
                onChange={({ id }) => {
                  setForm({ ...form, status_exemplar_id: id })
                }}
                reset={event => (resetStatus.current = event)}
              />
            </Grid>
            {submitMethod === 'post' && (
              <Grid item xs={12} sm={2}>
                <SmallTextField
                  value={quantidade}
                  onChange={e => setQuantidade(e.target.value)}
                  label="Quantidade"
                  {...helpers.quantidade}
                  type="number"
                />
              </Grid>
            )}
            <Grid item xs={12} sm={submitMethod === 'post' ? 4 : 6}>
              <SmallTextField
                value={form.observacao}
                onChange={e => setForm({ ...form, observacao: e.target.value })}
                label="Observações"
                {...helpers.observacao}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} sx={{ mt: '32px' }}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
          >
            <Button
              onClick={submitOptions[submitMethod]}
              type="submit"
              variant="contained"
              color="leitura"
            >
              {title[submitMethod]}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}
FormExemplar.propTypes = {
  idObra: number,
  onSubmit: func,
  idExemplar: number,
  submitMethod: string,
  dados: object
}
export default FormExemplar
